import { createFileRoute } from "@tanstack/react-router";

import { BasicVideoPlayer } from "~/components/basic-video-player/basic-video-player";
import { css } from "~/styled-system/css";

export const Route = createFileRoute("/storybook/video")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className={gridStyles}>
      <BasicVideoPlayer
        src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
        autoPlay
        muted
        loop
        theme={{ rounded: "lg" }}
        controls={{ play: true, progress: true, time: true }}
      />
      <BasicVideoPlayer
        src="https://stream.mux.com/sGJ00N4yrVIu201mobC7ksmjiLcmK4I9lqNZhVeZ745CY.m3u8"
        autoPlay
        muted
        loop
        theme={{ rounded: "md" }}
        controls={{ play: true, time: true }}
      />
    </div>
  );
}

const gridStyles = css({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "16px",
});
